export default "__VITE_ASSET__COnMFvjt__"